<template>
  <div id="app">
    <headerView :seletedindex="seletedindex" />
    <el-menu class="el-menu_img">
      <el-carousel indicator-position="none" height="90vh">
        <el-carousel-item v-for="(item, index) in gHomeBanner" :key="index">
          <div class="container"></div>
          <div class="bannertitle">
            <p class="bannertitle1">{{ item.title }}</p>
            <p class="bannertitle2">{{ item.subTitle }}</p>
            <!-- <el-button plain class="bannerbutton">了解更多</el-button> -->
          </div>
          <img
            :src="item.imgUrl"
            alt
            srcset
            class="index_banner"
            draggable="false"
          />
        </el-carousel-item>
      </el-carousel>
    </el-menu>
    <div>
      <!-- <div class="EducationalPhilosophy">
        <p class="EducationalPhilosophy_title">教育理念</p>
        <div class="EducationalPhilosophy_div">
          <el-card class="EducationalPhilosophy_card">
            <p
              class="icon iconfont icon-dengpao-tianchong"
              style="color: #1e3a8a !important"
            ></p>
            <p class="EducationalPhilosophy_card_p1">寓教于乐</p>
            <p class="EducationalPhilosophy_card_p2">让学习充满乐趣和创造力</p>
          </el-card>
          <el-card class="EducationalPhilosophy_card">
            <p class="icon iconfont icon-xueshimao"></p>
            <p class="EducationalPhilosophy_card_p1">授之以渔</p>
            <p class="EducationalPhilosophy_card_p2">培养独立思考和学习能力</p>
          </el-card>
          <el-card class="EducationalPhilosophy_card">
            <p
              class="icon iconfont icon-shuben"
              style="color: #1e3a8a !important"
            ></p>
            <p class="EducationalPhilosophy_card_p1">学以致用</p>
            <p class="EducationalPhilosophy_card_p2">理论与实践紧密结合</p>
          </el-card>
          <el-card class="EducationalPhilosophy_card">
            <p class="icon iconfont icon-wenhuahuodong"></p>
            <p class="EducationalPhilosophy_card_p1">五育并举</p>
            <p class="EducationalPhilosophy_card_p2">德智体美劳全面发展</p>
          </el-card>
        </div>
      </div>
      <div class="core_competency_development">
        <p class="core_competency_development_title">核心能力培养</p>
        <div class="core_competency_development_div">
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-zhinanzhen"></p>
            <p class="core_competency_development_card_p1">观察力</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p
              class="icon iconfont icon-dengpao-tianchong"
              style="color: #3b82f6 !important"
            ></p>
            <p class="core_competency_development_card_p1">想象力</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-tiaoseban"></p>
            <p class="core_competency_development_card_p1">审美力</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-kongjian"></p>
            <p class="core_competency_development_card_p1">逻辑思维</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-pintu"></p>
            <p class="core_competency_development_card_p1">空间思维</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p
              class="icon iconfont icon-shuben"
              style="color: #3b82f6 !important"
            ></p>
            <p class="core_competency_development_card_p1">创造思维</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-xiaoxi"></p>
            <p class="core_competency_development_card_p1">沟通表达</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-gongju-fill"></p>
            <p class="core_competency_development_card_p1">搭建调试</p>
          </el-card>
          <el-card class="core_competency_development_card">
            <p class="icon iconfont icon-wentijiejuejindu"></p>
            <p class="core_competency_development_card_p1">问题解决</p>
          </el-card>
        </div>
      </div> -->
      <div class="education_technology">
        <p class="education_technology_title">教育科技</p>
        <div class="education_technology_grid">
          <!-- 青少年科创教育 - 左，跨两行 -->
          <div class="education_tech_item education_tech_item_large" ref="item1">
            <div class="education_tech_graphic" :class="{ 'animate-in': animateItem1 }">
              <img src="@/assets/images/youth-innovation.png" alt="青少年科创教育" class="education_tech_graphic_img" />
            </div>
            <div class="education_tech_card" :class="{ 'animate-in': animateItem1 }">
              <h3>青少年科创教育</h3>
              <p>独创"九大核心能力模型",打造国家级赛事冠军的摇篮。</p>
            </div>
          </div>
          
          <!-- 政企数字化培训 - 中间上 -->
          <div class="education_tech_item" ref="item2">
            <div class="education_tech_card" :class="{ 'animate-in-up': animateItem2 }">
              <h3>政企数字化培训</h3>
              <p>"理论+案例+实战"三维教学,智改数转星级服务商。</p>
            </div>
          </div>
          
          <!-- 人工智能与低空经济 - 右中上 -->
          <div class="education_tech_item" ref="item3">
            <div class="education_tech_card" :class="{ 'animate-in': animateItem3 }">
              <h3>人工智能与低空经济</h3>
              <p>深耕AI算法与低空应用,为未来科技提供智慧支持。</p>
            </div>
          </div>
          
          <!-- 政企数字化培训 - 中间下 -->
          <div class="education_tech_item" ref="item4">
            <div class="education_tech_graphic education_tech_graphic_gears" :class="{ 'animate-in-up': animateItem4 }">
              <img src="@/assets/images/digital-training.png" alt="政企数字化培训" class="education_tech_graphic_img" />
              <div class="education_tech_graphic_content">
              </div>
            </div>
          </div>
          
          <!-- 人工智能与低空经济 - 右中下 -->
          <div class="education_tech_item" ref="item5">
            <div class="education_tech_graphic education_tech_graphic_drone" :class="{ 'animate-in': animateItem5 }">
              <img src="@/assets/images/ai-low-altitude.png" alt="人工智能与低空经济" class="education_tech_graphic_img" />
              <div class="education_tech_graphic_content">
              </div>
            </div>
          </div>
          
          <!-- 银发终身学习 - 右，跨两行 -->
          <div class="education_tech_item education_tech_item_large" ref="item6">
            <div class="education_tech_photo" :class="{ 'animate-in-up': animateItem6 }">
              <img src="@/assets/images/elderly-learning.png" alt="银发终身学习" />
            </div>
            <div class="education_tech_card" :class="{ 'animate-in-up': animateItem6 }">
              <h3>银发终身学习</h3>
              <p>"科技+文化+旅游"课程矩阵,助力银发族乐享数字生活。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="cdata">
        <el-carousel
          :interval="3000"
          :loop="true"
          indicator-position="none"
          arrow="never"
          height="200px"
          class="cdata_carousel"
        >
          <el-carousel-item
            v-for="(item, index) in collegeDataList"
            :key="index"
          >
            <div class="college_data">
              <p class="college_data_p1">{{ item.value }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="educational_services">
        <p class="educational_services_title">教育服务</p>
        <div class="educational_services_div">
          <div
            class="educational_services_div_main"
            v-for="(item, index) in listOfEducationalServices"
            :key="index"
          >
            <img
              :src="item.imgUrl"
              draggable="false"
              alt
              srcset
              class="educational_services_div_img"
            />
            <p class="educational_services_div_p1">
              <span class="icon iconfont" :class="item.icon"></span>
              <span>{{ item.title }}</span>
            </p>
            <p class="educational_services_div_p2">{{ item.description }}</p>
          </div>
        </div>
      </div>
      <div class="qualification_certification">
        <p class="qualification_certification_title">资质认证</p>
        <div class="qualification_certification_div">
          <el-card class="qualification_certification_card">
            <p>
              <span class="icon iconfont icon-jiangbei"></span>
              <span class="qualification_certification_p1"
                >全国青少年机器人等级考试服务中心</span
              >
            </p>
          </el-card>
          <el-card class="qualification_certification_card">
            <p>
              <span class="icon iconfont icon-jiangbei"></span>
              <span class="qualification_certification_p1"
                >软件编程等级考试服务中心</span
              >
            </p>
          </el-card>
          <el-card class="qualification_certification_card">
            <p>
              <span class="icon iconfont icon-jiangbei"></span>
              <span class="qualification_certification_p1"
                >江苏省青少年科技教育协会会员单位</span
              >
            </p>
          </el-card>
          <el-card class="qualification_certification_card">
            <p>
              <span class="icon iconfont icon-jiangbei"></span>
              <span class="qualification_certification_p1"
                >南通市科普教育基地</span
              >
            </p>
          </el-card>
        </div>
      </div>
      <div class="news_information">
        <p class="news_information_title">新闻动态</p>
        <div class="news_information_div">
          <div
            class="news_information_item"
            v-for="(item, index) in newsList"
            :key="index"
            @click="viewDetails(item.id, item.linkUrl,index)"
          >
            <img
              :src="item.imgUrl"
              draggable="false"
              alt
              class="news_information_item_img"
            />
            <div class="news_information_item_content">
              <p class="news_information_card_p1">{{ item.title }}</p>
              <p class="news_information_item_desc">{{ item.subTitle }}</p>
              <p class="news_information_card_p2">
                <span class="el-icon-date"></span>
                <span>{{ item.addTime }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerView></footerView>
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, Getnews, geteducationalServices,changeBrowsingFrequency } from "@/api/index";
import { timeformat } from "@/utils/timeformat";
export default {
  components: { headerView, footerView },
  data() {
    return {
      seletedindex: 0,
      gHomeBanner: [],
      newsList: [],
      listOfEducationalServices: [],
      collegeDataList: [
        { value: "10+ 年行业深耕" },
        { value: "200,000+人次培训规模" },
        { value: "1000+ 项省市级以上奖项" },
        { value: "7+ 家分子公司辐射全国" },
      ],
      animateItem1: false,
      animateItem2: false,
      animateItem3: false,
      animateItem4: false,
      animateItem5: false,
      animateItem6: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getHomeBanner();
      this.getNewsList();
      this.getEducationServiceList();
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.setupAnimationObserver();
    });
  },
  methods: {
    random(index) {
      if (index == 0) {
        return "icon-fuwu";
      }
      if (index == 1) {
        return "icon-icon-test";
      }
      if (index == 2) {
        return "icon-a-2-2";
      }
    },
    async getEducationServiceList() {
      const res = await geteducationalServices("/api/zaoying/educational");
      if (res.length > 0) {
        this.listOfEducationalServices = [
          ...res.map((item, index) => {
            return {
              icon: this.random(index),
              title: item.title,
              description: item.description,
              imgUrl: item.imgUrl,
            };
          }),
        ].slice(0, 3);
      }
    },
    async getHomeBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 6 });
      if (res.length > 0) {
        this.gHomeBanner = res;
      }
    },
    async getNewsList() {
      const news = await Getnews("/api/zaoying/news", { category_id: "" });
      if (news && news.items.length > 0) {
        this.newsList = news.items
          .map((item) => {
            return {
              id: item.id,
              title: item.title,
              imgUrl: item.imgUrl,
              subTitle: item.subTitle,
              linkUrl: item.linkUrl,
              addTime: timeformat(item.addTime),
            };
          })
          .slice(0, 3);
      }
    },

    async viewDetails(id, url,index) {
      const res = await changeBrowsingFrequency("api/zaoying/browse", { id: id });
      this.newsList[index].click += 1;
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: id,
          },
        });
      }
    },
    setupAnimationObserver() {
      // 检查浏览器是否支持 Intersection Observer
      if (!window.IntersectionObserver) {
        // 如果不支持，直接显示所有元素
        this.animateItem1 = true;
        this.animateItem2 = true;
        this.animateItem3 = true;
        this.animateItem4 = true;
        this.animateItem5 = true;
        this.animateItem6 = true;
        return;
      }

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 通过比较DOM元素来判断是哪个ref
            if (entry.target === this.$refs.item1) this.animateItem1 = true;
            if (entry.target === this.$refs.item2) this.animateItem2 = true;
            if (entry.target === this.$refs.item3) this.animateItem3 = true;
            if (entry.target === this.$refs.item4) this.animateItem4 = true;
            if (entry.target === this.$refs.item5) this.animateItem5 = true;
            if (entry.target === this.$refs.item6) this.animateItem6 = true;
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      // 观察所有元素
      this.$nextTick(() => {
        if (this.$refs.item1) observer.observe(this.$refs.item1);
        if (this.$refs.item2) observer.observe(this.$refs.item2);
        if (this.$refs.item3) observer.observe(this.$refs.item3);
        if (this.$refs.item4) observer.observe(this.$refs.item4);
        if (this.$refs.item5) observer.observe(this.$refs.item5);
        if (this.$refs.item6) observer.observe(this.$refs.item6);
      });
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* min-width: 1200px; */
}

.section-card {
  margin-bottom: 20px;
}

h1,
h2,
h3 {
  margin: 0;
}

.el-menu_img {
  width: 100vw;
  height: 86vh;
  overflow: hidden;
  z-index: -1;
}

.index_banner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 容器样式 */
.container {
  z-index: 98;
  position: absolute;
  width: 63%;
  height: 86vh;
  background: linear-gradient(
    to right,
    rgba(47, 77, 132, 0.5),
    rgba(200, 160, 255, 0)
  );
  filter: drop-shadow(10px 10px 20px rgba(47, 77, 132, 0.5));
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.bannertitle {
  z-index: 99;
  position: absolute;
  width: 100%;
  height: 86vh;
  text-align: left;
  top: 0;
  left: 0;
  line-height: 60px;
  color: #fff;
}
.bannertitle1 {
  position: absolute;
  left: 8%;
  top: 30%;
  font-size: 50px;
  letter-spacing: 5px;
}
.bannertitle2 {
  position: absolute;
  left: 8%;
  top: calc(30% + 60px);
  letter-spacing: 3px;
}
.bannerbutton {
  color: #1e3a8a;
  font-weight: bold;
  font-size: 16px;
}
.EducationalPhilosophy {
  width: 100%;
}

.EducationalPhilosophy_title {
  font-weight: bold;
  font-size: 30px;
  padding: 63px 0px;
}

.EducationalPhilosophy_div {
  width: 80%;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.EducationalPhilosophy_card {
  min-width: 250px;
  width: 22%;
  min-height: 176px;
  line-height: 1.5;
  border-radius: 15px;
}

.EducationalPhilosophy_card_p1 {
  font-weight: bold;
  font-size: 20px;
}

.EducationalPhilosophy_card_p2 {
  color: #78808a;
}

.core_competency_development {
  width: 100%;
  margin-top: 50px;
}

.core_competency_development_title {
  font-weight: bold;
  font-size: 30px;
  padding: 63px 0px;
}

.core_competency_development_div {
  width: 80%;
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.core_competency_development_card {
  min-width: 200px;
  width: 30%;
  line-height: 1.5;
  margin: 20px 0px;
  border-radius: 15px;
}

.core_competency_development_card .iconfont {
  font-size: 42px;
}

.core_competency_development_card_p1 {
  font-weight: bold;
  font-size: 20px;
}

.education_technology {
  width: 100%;
  padding: 63px 0;
  background-color: #fff;
}

.education_technology_title {
  font-weight: bold;
  font-size: 30px;
  color: #000;
  margin-bottom: 50px;
  text-align: center;
}

.education_technology_grid {
  width: 80%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr 2fr;
  gap: 20px;
  grid-auto-flow: row;
}

.education_tech_item {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 动画效果 - 从上往下（第一列和第三列） */
.education_tech_graphic.animate-in,
.education_tech_photo.animate-in {
  animation: slideDown 0.8s ease-out forwards;
}

.education_tech_card.animate-in {
  animation: slideDown 0.8s ease-out 0.2s forwards;
}

/* 初始状态 - 从上往下 */
.education_tech_item:nth-child(1) .education_tech_graphic:not(.animate-in),
.education_tech_item:nth-child(1) .education_tech_card:not(.animate-in),
.education_tech_item:nth-child(3) .education_tech_card:not(.animate-in),
.education_tech_item:nth-child(5) .education_tech_graphic:not(.animate-in) {
  opacity: 0;
  transform: translateY(-200px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

/* 动画效果 - 从下往上（第二列和第四列） */
.education_tech_graphic.animate-in-up,
.education_tech_photo.animate-in-up {
  animation: slideUp 0.8s ease-out forwards;
}

.education_tech_card.animate-in-up {
  animation: slideUp 0.8s ease-out 0.2s forwards;
}

/* 初始状态 - 从下往上 */
.education_tech_item:nth-child(2) .education_tech_card:not(.animate-in-up),
.education_tech_item:nth-child(4) .education_tech_graphic:not(.animate-in-up),
.education_tech_item:nth-child(6) .education_tech_photo:not(.animate-in-up),
.education_tech_item:nth-child(6) .education_tech_card:not(.animate-in-up) {
  opacity: 0;
  transform: translateY(100px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.education_tech_item_large {
  grid-row: span 2;
}

.education_tech_item:nth-child(1) {
  grid-column: 1;
  grid-row: 1 / 3;
}

.education_tech_item:nth-child(2) {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.education_tech_item:nth-child(3) {
  grid-column: 3;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.education_tech_item:nth-child(4) {
  grid-column: 2;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.education_tech_item:nth-child(5) {
  grid-column: 3;
  grid-row: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.education_tech_item:nth-child(6) {
  grid-column: 4;
  grid-row: 1 / 3;
}

.education_tech_card {
  background: #85b4f2;
  padding: 20px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 10px;
}

.education_tech_item_large .education_tech_card {
  max-height: 35%;
  flex: 0 0 auto;
}

.education_tech_item:nth-child(2) .education_tech_card,
.education_tech_item:nth-child(3) .education_tech_card {
  flex: 1;
  height: 100%;
  margin-top: 0;
}

.education_tech_card h3 {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 10px 0;
  color: #fff;
}

.education_tech_card p {
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
}

.education_tech_graphic {
  padding: 40px 20px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
  height: 100%;
}

.education_tech_item_large .education_tech_graphic {
  flex: 1;
  height: 100%;
}

.education_tech_graphic_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 1;
  opacity: 0.8;
}

.education_tech_graphic_content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
}

.education_tech_graphic_content h3 {
  font-size: 24px;
  font-weight: bold;
  margin: 0 0 10px 0;
  color: #fff;
}

.education_tech_graphic_content p {
  font-size: 14px;
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
}

.education_tech_graphic_gears {
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  height: 100%;
  flex: 1;
  margin-bottom: 0;
}

.education_tech_graphic_drone {
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
  height: 100%;
  flex: 1;
  margin-bottom: 0;
}

.education_tech_photo {
  flex: 1;
  overflow: hidden;
  background-color: #f3f4f6;
  margin-bottom: 10px;
  height: 100%;
}

.education_tech_photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .education_technology_grid {
    width: 90%;
  }
}

@media (max-width: 768px) {
  .education_technology_grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
  }
  
  .education_tech_item:nth-child(1),
  .education_tech_item:nth-child(6) {
    grid-column: span 2;
    grid-row: span 1;
  }
  
  .education_tech_item:nth-child(2),
  .education_tech_item:nth-child(3),
  .education_tech_item:nth-child(4),
  .education_tech_item:nth-child(5) {
    grid-column: span 1;
    grid-row: span 1;
  }
}

@media (max-width: 480px) {
  .education_technology_grid {
    grid-template-columns: 1fr;
  }
  
  .education_tech_item {
    grid-column: 1 !important;
    grid-row: auto !important;
  }
}

.cdata {
  width: 100%;
  min-height: 200px;
  line-height: 1.5;
  margin: 50px auto;
  background-color: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cdata_carousel {
  width: 100%;
  background-color: #eff6ff;
}

.cdata_carousel .el-carousel__arrow {
  display: none !important;
}

.cdata_carousel .el-carousel__item {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eff6ff;
}

.college_data {
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;
}

.college_data_p1 {
  font-weight: bold;
  font-size: 35px;
  color: #1e3a8a;
  display: inline-block;
  margin: 0;
  user-select: none;
}

.college_data_p2 {
  color: #4b5563;
  font-size: 16px;
  display: inline-block;
  margin: 0;
  user-select: none;
}

.educational_services {
  width: 100%;
}

.educational_services_title {
  font-weight: bold;
  font-size: 30px;
  padding: 63px 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
}

.educational_services_title::before,
.educational_services_title::after {
  content: "";
  width: 80px;
  height: 2px;
  background: linear-gradient(to right, transparent, #3b82f6, transparent);
}

.educational_services_title::before {
  background: linear-gradient(to left, transparent, #3b82f6, transparent);
}

.educational_services_div {
  width: 80%;
  margin: 0px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.educational_services_div_main {
  min-width: 200px;
  width: 30%;
  line-height: 2;
  margin: 20px 0px;
  border-radius: 15px;
}

.educational_services_div_img {
  width: 100%;
  height: 250px;
  border-radius: 10px;
}

.educational_services_div_p1 {
  text-align: left;
}

.educational_services_div_p1 span {
  font-weight: bold;
  padding: 0px 5px;
  font-size: 20px;
}

.educational_services_div_p2 {
  text-align: left;
  padding: 0px 5px;
  color: #4b5563;
}

.qualification_certification {
  width: 100%;
}

.qualification_certification_title {
  font-weight: bold;
  font-size: 30px;
  padding: 63px 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
}

.qualification_certification_title::before,
.qualification_certification_title::after {
  content: "";
  width: 80px;
  height: 2px;
  background: linear-gradient(to right, transparent, #3b82f6, transparent);
}

.qualification_certification_title::before {
  background: linear-gradient(to left, transparent, #3b82f6, transparent);
}

.qualification_certification_div {
  width: 80%;
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.qualification_certification_card {
  min-width: 430px;
  width: 49%;
  line-height: 1.5;
  margin: 20px 0px;
  border-radius: 15px;
  text-align: left;
}

.qualification_certification_p1 {
  clear: both;
  padding: 0px 20px;
  font-size: 20px;
  font-weight: bold;
  vertical-align: 25%;
}

.news_information {
  width: 100%;
  padding-bottom: 60px;
}

.news_information_title {
  font-weight: bold;
  font-size: 30px;
  padding: 63px 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
}

.news_information_title::before,
.news_information_title::after {
  content: "";
  width: 80px;
  height: 2px;
  background: linear-gradient(to right, transparent, #3b82f6, transparent);
}

.news_information_title::before {
  background: linear-gradient(to left, transparent, #3b82f6, transparent);
}

.news_information_div {
  width: 90%;
  max-width: 1400px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
}

.news_information_item {
  display: flex;
  align-items: flex-start;
  gap: 40px;
  padding: 35px 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #ffffff;
}

.news_information_item:hover {
  background: #fafafa;
}

.news_information_item_img {
  width: 260px;
  height: 180px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
}

.news_information_item_content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.news_information_card_p1 {
  font-weight: bold;
  font-size: 24px;
  color: #1f2937;
  margin-bottom: 15px;
  line-height: 1.4;
  text-align: left;
  display: inline-block;
}

.news_information_card_p1::after {
  content: "";
  display: block;
  width: 40px;
  height: 4px;
  background: #3b82f6;
  margin-top: 10px;
}

.news_information_item_desc {
  color: #6b7280;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  width: 100%;
}

.news_information_card_p2 {
  color: #9ca3af;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>